export const RESOURCE_TYPE_CONNECT_PROJECT = 'CONNECT_PROJECT';
